<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-body">
            <slot name="body">
              <div class="" role="main">
                <div class="page-title">
                  <div class="title_left">
                    <h3>{{ modalTitle }}</h3>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 col-sm-12 col-xs-12">
                    <div class="x_panel">
                      <div class="x_content">
                        <div
                          id="datatable_wrapper"
                          class="
                            dataTables_wrapper
                            form-inline
                            dt-bootstrap
                            no-footer
                          "
                        >
                          <div class="row">
                            <div class="col-sm-6">
                              <table-length
                                @changeRowPerPage="changeRowPerPageCount"
                              />
                            </div>
                            <div class="col-sm-6">
                              <div
                                id="datatable_filter"
                                class="dataTables_filter"
                              >
                                <label
                                  >{{ $t('common.search') }}:
                                  <input
                                    v-model="searchString"
                                    @input="searchWord"
                                    type="search"
                                    class="form-control input-sm"
                                    placeholder=""
                                    aria-controls="datatable"
                                  />
                                </label>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-12">
                              <app-table
                                :column-titles="tableHeaderColumns"
                                :display-items="displayItems"
                                @checkBoxEvent="checkBoxEvent"
                                @RadioButtonEvent="RadioButtonEvent"
                                @sortTable="sortTable"
                              />
                              <pagination
                                :page-par-item-count="displayItemPerPageCount"
                                :total-item-count="totalItemCount"
                                :current-page="currentPage"
                                @changePage="changePage"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="text-right">
                          <button
                            @click="$emit('close')"
                            class="btn btn-default dialogbtn_cancel"
                          >
                            {{ $t('common.cancel') }}
                          </button>
                          <button
                            @click="add"
                            class="btn btn-primary dialogbtn"
                          >
                            {{ $t('common.add') }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import Table from '@/components/common/table/Table'
import TableLength from '@/components/tabale/TableLength'
import Pagination from '@/components/tabale/Pagination'
import list from '@/mixin/list'
import config from '@/config/config'
export default {
  name: 'Modal',
  components: {
    AppTable: Table,
    TableLength,
    Pagination,
  },
  mixins: [list],
  props: ['tableHeaderItems', 'listItems', 'current'],
  data() {
    return {
      tableHeaderColumns: [],
      modalTitle: String,
      checkedDisabled: false,
    }
  },
  mounted() {
    if (this.current === 'recommend' || this.current === 'order') {
      this.tableHeaderColumns = [
        '',
        this.$t('common.itemCode'),
        this.$t('common.itemName'),
        this.$t('common.manufacturingCategory'),
        this.$t('common.topping'),
      ]
      this.modalTitle = this.$t('orderPage.lineup')
    } else {
      this.tableHeaderColumns = [
        '',
        this.$t('eventInformationPage.groupId'),
        this.$t('eventInformationPage.groupName'),
      ]
      this.modalTitle = this.$t('eventInformationPage.shopGroupList')
    }

    this.fetchItems = this.listItems
    this.allItems = this.listItems
    this.totalItemCount = this.allItems.length
    this.displayItems = this.allItems.slice(0, this.displayItemPerPageCount)
  },
  updated() {
    this.checkboxDisabled()
  },
  methods: {
    checkBoxEvent: function(bool, id) {
      const index = this.listItems.findIndex((item) => item[1] === id)
      this.listItems[index][0].checked = bool

      this.checkboxDisabled()
    },
    RadioButtonEvent: function(value) {
      this.listItems.map((item) => {
        item[0].checked = value
        return item
      })
    },
    sortTable: function(newArray) {
      this.displayItems = newArray
    },

    // 追加ボタンのイベント
    add: function() {
      let inputValues = []
      this.listItems.map((item) => {
        if (this.current === 'order') {
          if (item[1] === this.listItems[0][0].checked) {
            inputValues.push(item[2])
          }
        } else if (this.current === 'shop') {
          if (item[0].checked) {
            inputValues.push(item[2].title)
          }
        } else {
          if (item[0].checked) {
            inputValues.push(item[2])
          }
        }
      })

      this.$emit('valueInput', inputValues)
    },

    // チェックボックスをdisabledにする
    checkboxDisabled: function() {
      if (this.current === 'recommend') {
        let countChecked = 0
        this.listItems.forEach((item) => {
          if (item[0].checked) {
            countChecked++
          }
        })

        this.listItems.forEach((item) => {
          const inputTag = document.getElementById(item[1])
          if (inputTag === null) {
            return
          }
          if (item[0].checked) {
            inputTag.removeAttribute('disabled', 'disabled')
          } else {
            if (countChecked >= config.maxRecommendMenu) {
              inputTag.setAttribute('disabled', 'disabled')
            } else {
              inputTag.removeAttribute('disabled', 'disabled')
            }
          }
        })
      }
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: inherit;
  transition: opacity 0.3s ease;
  text-align: left;
}

.modal-wrapper {
  display: flex;
  align-items: center;
  height: 100vh;
}

.modal-container {
  width: 80%;
  max-height: 80%;
  overflow-y: auto;
  margin: 0px auto;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  max-height: 80%;
  overflow-y: hidden;
}
.modal-body .page-title {
  width: auto;
}

.modal-default-button {
  float: right;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

input[type='checkbox'] {
  margin: 0 auto;
  text-align: center;
  display: block;
}
</style>
